/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { history } from "../../router/router";
import { MainPageEvent, useMainPageDataSelector } from "../MainUi";
import { useHomePageDataSelector } from "../Pages/HomePage";

export interface MobileMenuProps {
  sideMenuClicked: boolean;
  setSideMenuClicked(b: boolean): void;
}

function MobileMenu({ sideMenuClicked, setSideMenuClicked }: MobileMenuProps) {
  const dispatch = useDispatch();
  const mainPageData = useMainPageDataSelector();
  const homePageData = useHomePageDataSelector();
  const [keyword, setKeyword] = useState<string>("");

  return (
    <div className={sideMenuClicked ? "mobile-menu active" : "mobile-menu"}>
      <div className="row no-gutters">
        <div className="col-7">
          <a
            href="http://dev.bdapps.com/"
            className="btn btn-primary w-100 mobile-menu__left-btn"
          >
            <i className="fas fa-plus"></i> Create You Own App
          </a>
        </div>
        <div className="col-5">
          {mainPageData.authState ? (
            <button
              className="btn btn-primary w-100"
              onClick={() => {
                dispatch({
                  type: MainPageEvent.SIGN_OUT,
                });
                setSideMenuClicked(false);
                history.push("/");
              }}
            >
              Logout
            </button>
          ) : (
            <button
              className="btn btn-primary w-100"
              onClick={() => {
                setSideMenuClicked(false);
                dispatch({
                  type: MainPageEvent.SHOW_SIGNIN_MODAL,
                });
              }}
            >
              Sign In
            </button>
          )}
        </div>
      </div>
      <div className="input-group pt-2">
        <input
          className="form-control border-0 bg-back"
          type="search"
          placeholder="Search Apps"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
        />
        <Link
          className="input-group-prepend"
          to={"/search-apps/" + keyword}
          onClick={() => {
            setSideMenuClicked(false);
          }}
        >
          <button className="btn btn-primary">
            <i className="fas fa-search"></i>
          </button>
        </Link>
      </div>
      <ul className="mobile-menu-list common-list">
        <li className="mobile-menu-list__item">
          <Link
            to="/"
            className="mobile-menu-list__item-link active"
            onClick={() => {
              setSideMenuClicked(false);
            }}
          >
            All Apps
          </Link>
        </li>
        <li className="mobile-menu-list__item">
          <Link
            to="/new-apps"
            className="mobile-menu-list__item-link"
            onClick={() => {
              setSideMenuClicked(false);
            }}
          >
            Newly Added Apps
          </Link>
        </li>
        <li className="mobile-menu-list__item">
          <Link
            to="/top-rated-apps"
            className="mobile-menu-list__item-link"
            onClick={() => {
              setSideMenuClicked(false);
            }}
          >
            Top Rated Apps
          </Link>
        </li>
        <li className="mobile-menu-list__item">
          <Link
            to="/most-used-apps"
            className="mobile-menu-list__item-link"
            onClick={() => {
              setSideMenuClicked(false);
            }}
          >
            Most Used Apps
          </Link>
        </li>
        {sessionStorage.getItem("isAuthed") === "true" && (
          <li className="mobile-menu-list__item">
            <Link
              to="/my-apps"
              className="mobile-menu-list__item-link"
              onClick={() => {
                setSideMenuClicked(false);
              }}
            >
              My Apps
            </Link>
          </li>
        )}
        <li className="mobile-menu-list__item">
          <p className="m-3 font-weight-bold">Category</p>
          <ul className="mobile-menu-list-sub-list common-list">
            <li className="mobile-menu-list-sub-list__item">
              {homePageData.categories &&
                homePageData.categories.map((category) => (
                  <Link
                    key={category.categoryName}
                    to={"/app-by-category/" + category.categoryName}
                    className="mobile-menu-list-sub-list__item-link"
                    onClick={() => {
                      setSideMenuClicked(false);
                    }}
                  >
                    <i className={category.icon} />
                    {category.categoryName}
                  </Link>
                ))}
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
}

export default MobileMenu;
